export default "__VITE_ASSET__BPkDkz65__"